<template>
        <img :src="mnbg" alt="Imagen de fondo" style="position: fixed;top: 0;left: 0;width: 100%;height: 100%;object-fit: cover;opacity: 0.05;z-index: -1;">
        <div class="container-fluid m-0 p-0" style="">
            <div class="row m-0 p-0">
                <div class="col-12 m-0 p-0">
                    <div class="d-flex justify-content-center mb-5 position-relative">
                        <img :src="magda" class="img-fluid" style="">
                        <p class="text-white title-sm epilogue-semibold position-absolute top-50 start-50 translate-middle">
                            Nuestros Eventos
                        </p>
                    </div>
                </div>
            </div>

            <div class="row mx-5" v-for="(card, index) in cards" :key="index" data-aos="flip-left">

    			<div class="col-12">
                    <a class="row blog_border my-3 border-start border-5 text-decoration-none text-dark" @click="router.push('/calendario');">
                        <div class="col-md-6 col-12">
                            <p class="text-start description-sm epilogue-semibold">{{ card.text }}</p>
                            <div class="d-flex justify-content-center align-items-center">
                                <img :src="card.logo" class="img-fluid w-50">
                            </div>
                        </div>
                        <div class="col-md-6 col-12">
                            <div class="d-flex justify-content-center carousel-slide mb-3" >
                                <div class="m-3">
                                    <img :src="card.image" loading="lazy"
                                    class="img-fluid"/>
                                    <p class="text-start description-xxs epilogue-regular">{{ card.date }}</p>
                                    <p class="text-start description-xs epilogue-semibold">{{ card.text }}</p>
                                    <p class="text-start description-xxs epilogue-regular">{{ card.text2 }}</p>
                                    <p class="text-start description-xxs epilogue-regular">Leer más</p>
                                </div>
                            </div>
                        </div>
                        
                    </a>

                </div>
            </div>
        </div>
</template>

<script setup>
    import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
    import { useRouter } from 'vue-router'
    import { useStore } from "vuex"

    const router = useRouter()

	import magda from "ASSETS/images/48"
	import magdamn from "ASSETS/images/Rectangle"
	import magdamn1 from "ASSETS/images/Rectangle2"
	import magdamn2 from "ASSETS/images/Rectangle3"
	import magdamn3 from "ASSETS/images/Rectangle4"

    import mnbg from "ASSETS/images/vectormn"

    import logo1 from "ASSETS/icons/logo1"
	import logo2 from "ASSETS/icons/logo2"
	import logo3 from "ASSETS/icons/logo3"
	import logo4 from "ASSETS/icons/logo4"
	import logo5 from "ASSETS/icons/logo5"

    const cards = [
        {
            logo: logo5,
            image: magdamn1,
            text: "Evento Cultural y Deportivo",
            text2: "El 23 de abril de 2016, realizamos un evento en la Penitenciaría de Santa Martha. Contamos con la participación del equipo de baloncesto 'Camaleones', promoviendo la reinserción social a través de actividades deportivas y culturales.",
            date: "23 de abril de 2016",
        },
        {
            logo: logo5,
            image: magdamn3,
            text: "Taller de Marionetas y Emociones",
            text2: "El 28 de marzo de 2023, llevamos a cabo un taller en la Biblioteca José Manuel Otón, CDMX, con niños de primaria. Trabajamos el desarrollo emocional a través de la creación de marionetas hechas con calcetines.",
            date: "28 de marzo de 2023",
        },
        {
            logo: logo5,
            image: magdamn,
            text: "Inicio de la Caravana Cultural Ambulante",
            text2: "En septiembre de 2012, iniciamos la Caravana Cultural Ambulante en el sistema penitenciario de CDMX. Este proyecto itinerante ha llevado experiencias culturales a comunidades marginadas a lo largo de los años.",
            date: "Septiembre de 2012",
        },
        {
            logo: logo5,
            image: magdamn2,
            text: "Nueva Alianza Interinstitucional",
            text2: "En 2024, consolidamos una alianza con IMJUVE, Pozos de Vida y Bibliotecas Populares para implementar programas culturales que beneficien a comunidades desfavorecidas en México.",
            date: "2024",
        },
    ];

</script>



<style lang="scss" scoped>

</style>
